export const CATEGORY_SET = [
  // "문화", "IT", "인물", "경제", "정치사회", "심리", "장소", "브랜드", "제품", "etc",
  // "blank"
  "문화", "IT", "인물", "경제", "정치사회", "심리", "장소", "브랜드", "제품"
]